import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { DropdownButton } from 'react-bootstrap';
import { userTaskSorter } from '../utils/sorting';
import * as list from '../utils/list';
import { quotaValidation } from '../constants';

import AutoUserInput from './AutoUserInput';
import Spinner from './Spinner';
import UsersOverviewAssignmentRemovalModal from './UsersOverviewAssignmentRemovalModal';
import UsersOverviewUserPillNewAssignmentBar from './UsersOverviewUserPillNewAssignmentBar';

import roles from '../utils/roles';

import UsersOverviewProjectPill from './UsersOverviewProjectPill';

import taskActions from '../actions/taskActionCreators';
import userActions from '../actions/userActionCreators';
import userTaskActions from '../actions/userTaskActionCreators';

/*
    keeps track of all projects
    manages weeklyQuota
    manages selecting of project type (active, closed, all)
    manages selecting of task type (active, closed, all)
    manages filtering projects for subcomponents
    manages assignment on new tasks and projects
    manages saving of all changes for certain user
    manages validation of new userTasks
*/
class UsersOverviewUserPill extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            activeProject: null,
            clearInputs: false,
            isEditingWeeklyQuota: false,    // for focusing on input box and showing glow effects //TODO
            newlyAssignedUserTasks: [],     // array of newly assigned user tasks
            newUTProject: null,
            newUTProjectError: false,
            newUTQuota: 0,
            newUTQuotaEditing: [], //map of new usertasksIDs to boolean which is true if it's quota is being edited (only 1 at a time can be true) //TODO
            newUTTask: null,
            newUTTaskError: false,
            newWeeklyQuota: this.props.user.weeklyQuota,
            projectDropdownTitle: "Active",
            projectNameToUserTasksMap: [],
            projectsByUser: [],
            quotaError: false,
            removedUserTasks: [],
            showModal: false,
            showActiveProjects: true,
            showActiveTasks: true,
            showArchivedProjects: false,
            showClosedTasks: false,
            taskDropdownTitle: "Active",
            updateFocused: false,
            userTasks: this.props.userTasks,
            userTaskIDToIsEditingQuotaMap: [],
            pendingDelegate: undefined,
            weeklyQuotaError: false,
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        if ( (this.props.isUserPillActive == false && nextProps.isUserPillActive == true)
            || (nextProps.isUserPillActive && this.props.userTasks != nextProps.userTasks)) {
            this.setState ({ projectNameToUserTasksMap: this.generateProjectNameToUserTaskMap(nextProps.userTasks) });
        }
        if ( nextProps.userTasks) {
            this.setState({ userTasks: nextProps.userTasks});
        }
        if ( nextProps.projectsByUser) {
            this.setState({projectsByUser: nextProps.projectsByUser});
        }
    }

    componentWillMount = () => {
        this.setState({
            newWeeklyQuota: this.props.user.weeklyQuota
        });
    }

    // EVENT HANDLERS

    handleClick = () => {
        this.setState({ isEditingWeeklyQuota: false,
                        newlyAssignedUserTasks: [],
                        newWeeklyQuota: this.props.user.weeklyQuota,
                        pendingDelegate: undefined });
        this.props.handleClick(this.props.user.id);
    }

    // used for loading data when project pill is clicked
    handleProjectClick = (project) => {
            if (this.state.activeProject) {
                this.setState({ activeProject: project.id === this.state.activeProject.id ? null : project });
            } else {
                this.setState({ activeProject: project });
            }
    }

    handleRemoveExisting = (userTask) => {
        let index = list.findIndexByID(this.state.userTasks, userTask.id);
        let newUserTasks = list.remove(this.state.userTasks, index);

        this.state.removedUserTasks.push(userTask);
        this.setState({
            userTasks: newUserTasks,
            projectNameToUserTasksMap: this.generateProjectNameToUserTaskMap(newUserTasks)
        });
    }

    handleRemoveNew = (key) => { this.state.newlyAssignedUserTasks.splice(key, 1); }

    handleSaveWeeklyQuota = (userID, newQuota) => { this.props.dispatch(userActions.changeWeeklyQuota(userID, newQuota)); }

    handleSaveTaskQuota = (userTaskID, newQuota) => { this.props.dispatch(userTaskActions.updateUserTaskQuota(userTaskID, newQuota)); }

    handleLoadTasksForNewUTSelection = () => { this.props.dispatch( taskActions.loadAssignableToUserByProject(this.props.user.id, this.state.newUTProject.id) )};

    // used on new assignment for loading selectable tasks
    handleSelectProjectForNewUT = (project) => { this.setState({ newUTProject: project }, this.handleLoadTasksForNewUTSelection) }

    handleSelectTaskForNewUT = (task) => { this.setState({ newUTTask: task }); }

    handleNewQuotaChange = (e) => {
        this.setState({ newUTQuota: e.target.value });
    }

    clearNewQuota = () => { this.setState({ newUTQuota: '' }); }

    handleToggleModal = () => { this.setState({ showModal: !this.state.showModal }); }

    handleUpdateBlur = () => { this.setState({  updateFocused: false }); }

    handleUpdateFocus = () => { this.setState({ updateFocused: true }); }

    handleUnsetQuota = () => {
        this.setState({
            newWeeklyQuota: null
        });
    }

    // DELEGATE METHODS

    getDelegateName = () => {
        let userByID = this.props.userByID;
        if (!userByID || Number(userByID.id) !== Number(this.props.user.id)) return null;
        return userByID.notificationDelegateName || null;
    }

    handleSetDelegate = (delegateUser) => {
        this.setState({ pendingDelegate: delegateUser });
    }

    handleClearDelegate = () => {
        this.setState({ pendingDelegate: null });
    }

    // OTHER METHODS

    // TODO currently unused
    isTaskAlreadyAssigned = (taskID) => { return list.findByTaskID(this.state.userTasks, taskID) || list.findByTaskID(this.state.newlyAssignedUserTasks, taskID) ? true : false; }

    // finished
    generateProjectNameToUserTaskMap = (userTasks) => {
        let projectNameToUserTasksMap = new Map;

        for (let ut of userTasks) {
            let key = ut.projectName;
            let utList = projectNameToUserTasksMap.get(key);
            if (utList == undefined) utList = new Array;
            utList.push(ut);
            projectNameToUserTasksMap.set(key, utList);
        }

        return projectNameToUserTasksMap;
    }
    setWeeklyQuotaEditingFlag = () => { this.setState({ isEditingWeeklyQuota: true }); }

    validateWeeklyQuota = () => {
        let quotaError = !quotaValidation.test(this.state.newWeeklyQuota)
                         || this.state.newWeeklyQuota < 0
                         || this.state.newWeeklyQuota > 40;

        this.setState({ weeklyQuotaError: quotaError });
    }

    validateQuota = () => { this.setState({ quotaError: !quotaValidation.test(this.state.currentNewQuota) }); }

    // returns false if errors exist nad sets error flags
    validateNewUserTask = () => {
        let taskError = this.props.selectedTask == null;
        let projectError = this.props.selectedProject == null;
        let quotaError = !quotaValidation.test(this.state.newUTQuota);

        this.setState({
            newUTTaskError: taskError,
            newUTProjectError: projectError,
            newUTQuotaError: quotaError
        });
        return taskError || projectError || quotaError ? false : true;
    }

    handleWeeklyQuotaBlur = () => {
        if (this.state.weeklyQuotaError) return;

        this.setState({ isEditingWeeklyQuota: false });
    }

    handleWeeklyQuotaChange = (event) => {
        this.setState({
            newWeeklyQuota: event.target.value.trim() == '' ? null : event.target.value.trim()
        }, this.validateWeeklyQuota);
    }

    handleNewlyAssignedQuotaClick = (userTaskID) => {
        let key;
        for (let i=0; i<this.state.newlyAssignedUserTasks.length; i++) {
            if (this.state.newlyAssignedUserTasks[i].id == userTaskID) {
                key = i;
            }
        }

        this.state.currentNewQuota = this.state.newlyAssignedUserTasks[key].quota / 60;
        this.state.newUTQuotaEditing[key] = true;
        //setTimeout(() => {
        //    ReactDOM.findDOMNode(this.refs["newUTQuotaInput" + key]).focus();
        //}, 50);
    }

    handleExistingQuotaBlur = (userTask, quota) => {

        let newUserTasks = this.state.userTasks;
        let index = list.findIndexByID(newUserTasks, userTask.id);
        newUserTasks[index].quotaChanged = true;
        newUserTasks[index].quota = quota * 60;

        this.setState({
            userTasks: newUserTasks,
            projectNameToUserTasksMap: this.generateProjectNameToUserTaskMap(newUserTasks)
        });
    }

    handleCreateUserTask = () => {
        if (!this.validateNewUserTask()) return;

        let userTask = {
            closed: false,
            overtimeTimeSpent: 0,
            project: this.props.selectedProject,
            projectArchived: this.props.selectedProject.archived,
            projectName: this.props.selectedProject.name,
            quota: this.state.newUTQuota * 60,
            regularTimeSpent: 0,
            task: this.props.selectedTask,
            taskClosed: this.props.selectedTask,
            taskName: this.props.selectedTask.name
        };

        this.state.newlyAssignedUserTasks.push(userTask);

        let flag = true;
        this.state.projectsByUser.filter(project => {
            if (project.id === this.props.selectedProject.id) {
                flag = false;
            }
        });
        if (flag) {
            this.state.projectsByUser.push(this.props.selectedProject);
        }

        this.setState({
            activeProject: null,
            clearInputs: true,
        });
        setTimeout(() => {
            this.setState({
                activeProject: this.props.selectedProject,
                clearInputs: false,
                newUTProject: null,
                newUTTask: null,
                newUTQuota: 0,
            });
        }, 500);

    }

    handleProjectSave = () => {
        // if quota on any task is being edited
        //if (list.findActiveIndexFromList(this.state.userTaskIDToIsEditingQuotaMap) != -1) return;

        let userTasks = this.state.removedUserTasks;
        for (let i = 0; i < userTasks.length; i++) {
            if (this.state.activeProject.name === userTasks[i].projectName)
                this.props.dispatch(userTaskActions.unassignUserFromTask(userTasks[i].id));
        }

        if (this.state.newlyAssignedUserTasks) {
            for (let i = 0; i < this.state.newlyAssignedUserTasks.length; i++) {
                if (this.state.activeProject.name === this.state.newlyAssignedUserTasks[i].projectName) {
                    let userTask = this.state.newlyAssignedUserTasks[i];
                    let quota = userTask.quota;

                    this.props.dispatch(userTaskActions.assignUserToTask(userTask.task.id, this.props.user, quota));
                }
            }
        }

        for (let i = 0; i < this.state.userTasks.length; i++) {
            if (this.state.userTasks[i].quotaChanged && this.state.activeProject.name === this.state.userTasks[i].projectName) {
                 this.props.dispatch(userTaskActions.updateQuota(this.state.userTasks[i].id, this.state.userTasks[i]));
            }
        }

        this.setState({
            removedUserTasks: []
        });
    }

    handleTaskTypeSelect = (key) => {
        if (key === 1) {
            this.setState({
                showActiveTasks: true,
                showClosedTasks: false,
                taskDropdownTitle: "Active"
            });
        } else if (key === 2) {
            this.setState({
                showActiveTasks: false,
                showClosedTasks: true,
                taskDropdownTitle: "Closed"
            });
        } else {
            this.setState({
                showActiveTasks: true,
                showClosedTasks: true,
                taskDropdownTitle: "All"
            });
        }
    }

    handleProjectTypeSelect = (key) => {
        if (key == 1) {
            this.setState({
                showActiveProjects: true,
                showArchivedProjects: false,
                projectDropdownTitle: "Active"
            });
        } else if (key == 2) {
            this.setState({
                showActiveProjects: false,
                showArchivedProjects: true,
                projectDropdownTitle: "Archived"
            });
        } else {
            this.setState({
                showActiveProjects: true,
                showArchivedProjects: true,
                projectDropdownTitle: "All"
            });
        }
    }

    handleSave = () => {
        if (this.state.weeklyQuotaError) return;

        let userTasks = this.state.removedUserTasks;
        for (let i = 0; i < userTasks.length; i++) {
            this.props.dispatch(userTaskActions.unassignUserFromTask(userTasks[i].id));
        }

        for (let i = 0; i < this.state.newlyAssignedUserTasks.length; i++) {
            let userTask = this.state.newlyAssignedUserTasks[i];
            let quota = userTask.quota;
            this.props.dispatch(userTaskActions.assignUserToTask(userTask.task.id, this.props.user, quota));
        }

        for (let i = 0; i < this.state.userTasks.length; i++) {
            if (this.state.userTasks[i].quotaChanged) {
                 this.props.dispatch(userTaskActions.updateQuota(this.state.userTasks[i].id, this.state.userTasks[i]));
            }
        }

        if (this.state.pendingDelegate !== undefined) {
            if (this.state.pendingDelegate === null) {
                this.props.dispatch(userActions.clearNotificationDelegate(this.props.user.id));
            } else {
                this.props.dispatch(userActions.setNotificationDelegate(this.props.user.id, this.state.pendingDelegate.id));
            }
        }

        if (this.state.newWeeklyQuota !== this.props.user.weeklyQuota || this.state.newlyAssignedUserTasks.length > 0) {
            this.handleSaveWeeklyQuota(this.props.user.id, this.state.newWeeklyQuota);
            this.handleClick();
        }
    }

    handleConfirmedDelete = () => {
        this.handleToggleModal();
        this.handleRemoveAllAssignments();
    }

    handleRemoveAllAssignments = () => {
        // create list copies
        let userTasks = this.props.userTasks.slice(0);
        let removedUserTasks = this.state.removedUserTasks.slice(0);

        for (let i = 0; i < userTasks.length; i++) {
            if (this.state.activeProject && this.state.activeProject.name === userTasks[i].projectName) {
                removedUserTasks.push(userTasks[i]);
            }
        }

        let index = list.findIndexByID(this.state.projectsByUser, this.state.activeProject.id);
        let projectsByUser = list.remove(this.state.projectsByUser, index);

        this.setState({
            projectsByUser: projectsByUser,
            newlyAssignedUserTasks: [],
            userTasks: [],
            removedUserTasks: removedUserTasks
        }, this.handleProjectSave);
    }

    // RENDER METHOD

    render = () => {
        if (!this.props.isUserPillActive) {
            return (
                <div className="panel panel-default panel-pmtask" >
                    <div className="panel-heading" role="tab" id="headingThree-outer">
                        <h4 className="panel-title" style={{backgroundColor : "#888"}}>
                        <a style={{"cursor" : "pointer"}} onClick={this.handleClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                            <span className="md-chevron-right"/>
                            {this.props.user.surname} {this.props.user.givenName}
                            <p className="pull-right">{this.props.user.weeklyQuota !== null ? this.props.user.weeklyQuota : ""} {this.props.user.weeklyQuota !== null ? "h" : "Not set"}</p>
                        </a>
                        </h4>
                    </div>
                    <div id="collapseThree-outer" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                        <div className="panel-body"/>
                    </div>
                </div>
            );
        } else {
            return (
                <div onKeyDown={this.handleKeyDown} className="panel panel-default panel-pmtask" >
                    {
                        this.state.showModal ? <UsersOverviewAssignmentRemovalModal
                                                    handleConfirmedDelete = {this.handleConfirmedDelete}
                                                    handleToggleModal = {this.handleToggleModal}
                                                    projectName = {this.state.activeProject.name}
                                                    user = {this.props.user}
                                                    />
                                            : null
                    }
                    <div className="panel-heading" role="tab" id="headingThree-outer">
                        <h4 className="panel-title" style={{backgroundColor : "#888"}}>
                        <a style={{"cursor" : "pointer"}} onClick={this.handleClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                            <span className="md-expand-more"/>
                            {this.props.user.surname} {this.props.user.givenName}
                        </a>
                        </h4>
                    </div>
                    <div id="collapseThree-outer" className="panel-collapse" role="tabpanel" aria-labelledby="headingThree">
                        <div className="panel-body">
                            <div className="form-group">
                                <h5>
                                    <div className="row">
                                        <label htmlFor="task_name" className="col-sm-2 control-label" style={{"display" : "flex", "height" : "30px", "flex-direction" : "column", "justify-content" : "center"}}>Weekly Quota:</label>
                                        {
                                            this.state.isEditingWeeklyQuota
                                              ? <div className={this.state.weeklyQuotaError ? "col-sm-1 has-error" : "col-sm-1"}>
                                                    <input
                                                        style={{"width" : "70px"}}
                                                        onChange={this.handleWeeklyQuotaChange}
                                                        value={this.state.newWeeklyQuota ? this.state.newWeeklyQuota : ""}
                                                        onBlur={this.handleWeeklyQuotaBlur}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Hours"/>
                                                </div>
                                              : <div className="col-sm-1">
                                                    <p style={{"cursor" : "pointer"}} className="form-control-static"  onClick={this.setWeeklyQuotaEditingFlag}>
                                                        {this.state.newWeeklyQuota !== null ? this.state.newWeeklyQuota : ""} {this.state.newWeeklyQuota !== null ? "h" : "Not set"}
                                                    </p>
                                                </div>
                                        }
                                        <div className="col-sm-2">
                                            <button title="Remove weekly quota for user" onClick={this.handleUnsetQuota} className="btn btn-default" style={{backgroundColor : "transparent"}}>Unset</button>
                                        </div>
                                        <label className="col-sm-1 control-label" style={{"display" : "flex", "height" : "30px", "flex-direction" : "column", "justify-content" : "center"}}>Projects:</label>
                                        <div className="col-sm-2">
                                            <DropdownButton
                                                id="projectDropdownButton1"
                                                style={{"backgroundColor" : "transparent"}}
                                                ref="projectDropdown"
                                                className="select"
                                                title={this.state.projectDropdownTitle}>
                                                    <li style={{"cursor" : "pointer"}} key={1} id="1" onClick={this.handleProjectTypeSelect.bind(this, 1)} role="presentation"><a>Active</a></li>
                                                    <li style={{"cursor" : "pointer"}} key={2} id="2" onClick={this.handleProjectTypeSelect.bind(this, 2)} role="presentation"><a>Archived</a></li>
                                                    <li style={{"cursor" : "pointer"}} key={3} id="3" onClick={this.handleProjectTypeSelect.bind(this, 3)} role="presentation"><a>All</a></li>
                                            </DropdownButton>
                                        </div>
                                        <label className="col-sm-1 control-label" style={{"display" : "flex", "height" : "30px", "flex-direction" : "column", "justify-content" : "center"}}>Tasks:</label>
                                        <div className="col-sm-2">
                                            <DropdownButton
                                                id="projectDropdownButton2"
                                                style={{"backgroundColor" : "transparent"}}
                                                ref="taskDropdown"
                                                className="select"
                                                title={this.state.taskDropdownTitle}>
                                                    <li style={{"cursor" : "pointer"}} key={1} id="1" onClick={this.handleTaskTypeSelect.bind(this, 1)} role="presentation"><a>Active</a></li>
                                                    <li style={{"cursor" : "pointer"}} key={2} id="2" onClick={this.handleTaskTypeSelect.bind(this, 2)} role="presentation"><a>Closed</a></li>
                                                    <li style={{"cursor" : "pointer"}} key={3} id="3" onClick={this.handleTaskTypeSelect.bind(this, 3)} role="presentation"><a>All</a></li>
                                            </DropdownButton>
                                        </div>
                                    </div>
                                </h5>
                            </div>
                            {
                                roles.userHasAnyOfRoles(this.props.currentUser, ['PMO'])
                                ? (() => {
                                    let delegateName = this.state.pendingDelegate !== undefined
                                        ? (this.state.pendingDelegate
                                            ? this.state.pendingDelegate.givenName + ' ' + this.state.pendingDelegate.surname
                                            : null)
                                        : this.getDelegateName();
                                    return <div className="form-group">
                                        <h5>
                                            <div className="row">
                                                <label className="col-sm-2 control-label" style={{"display" : "flex", "height" : "30px", "flex-direction" : "column", "justify-content" : "center"}}>Notification Delegate:</label>
                                                <div className="col-sm-2">
                                                    <p className="form-control-static">
                                                        {delegateName || "None"}
                                                    </p>
                                                </div>
                                                <div className="col-sm-3">
                                                    <AutoUserInput
                                                        users={this.props.usersForUsersOverview.filter(u => u.active)}
                                                        bannedUserIDs={[this.props.user.id]}
                                                        handleFunction={this.handleSetDelegate}
                                                        placeholder="Select delegate..."
                                                        keepAfterClick={false}
                                                        hideInactive={true}
                                                        enableClear={true}
                                                        forceInitialPopup={false}
                                                    />
                                                </div>
                                                {
                                                    delegateName
                                                    ? <div className="col-sm-2">
                                                        <button title="Clear notification delegate" onClick={this.handleClearDelegate} className="btn btn-default" style={{backgroundColor : "transparent"}}>Clear</button>
                                                      </div>
                                                    : null
                                                }
                                            </div>
                                        </h5>
                                    </div>;
                                  })()
                                : null
                            }
                            <br/><hr/>
                            {
                                this.state.projectsByUser.map((project, key) => {
                                    if (!(this.state.showActiveProjects && this.state.showArchivedProjects)) {
                                        if (this.state.showActiveProjects   && project.archived) return null;
                                        if (this.state.showArchivedProjects && !project.archived) return null;
                                    }
                                    //if the project has no old userTasks and no newly assigned userTasks, do not show it
                                    let newlyAssignedOfThisProject = this.state.newlyAssignedUserTasks.filter(userTask => {
                                        if (userTask.projectName == project.name)
                                            return true;
                                    });
                                    if (this.state.projectNameToUserTasksMap.get(project.name) == null && newlyAssignedOfThisProject.length == 0) {
                                        return null;
                                    }

                                    return (<UsersOverviewProjectPill
                                            userTaskIDToIsEditingQuotaMap = {this.state.userTaskIDToIsEditingQuotaMap}
                                            handleExistingQuotaBlur = {this.handleExistingQuotaBlur}
                                            handleNewlyAssignedQuotaBlur = {this.handleNewlyAssignedQuotaBlur}
                                            handleNewlyAssignedQuotaChange = {this.handleNewlyAssignedQuotaChange}
                                            handleNewlyAssignedQuotaClick = {this.handleNewlyAssignedQuotaClick}
                                            handleProjectClick = {this.handleProjectClick}
                                            handleProjectSave = {this.handleProjectSave}
                                            handleRemoveExisting = {this.handleRemoveExisting}
                                            handleRemoveNew = {this.handleRemoveNew}
                                            handleToggleModal = {this.handleToggleModal}
                                            id = {key}
                                            isActive = {this.state.activeProject && this.state.activeProject.id === project.id}
                                            key = {key}
                                            project = {project}
                                            quotaError = {this.state.quotaError}
                                            showActiveTasks = {this.state.showActiveTasks}
                                            showClosedTasks = {this.state.showClosedTasks}
                                            newlyAssigned = {this.state.newlyAssignedUserTasks}
                                            userTasks = {this.state.projectNameToUserTasksMap.get(project.name)}
                                            />);
                                })
                            }
                            {
                                this.props.isUserActive
                                    ?
                                        this.props.tasksLoading
                                            ?
                                                <Spinner />
                                            :
                                                <UsersOverviewUserPillNewAssignmentBar
                                                    clearNewQuota={this.clearNewQuota}
                                                    clearInputs={this.state.clearInputs}
                                                    handleCreateUserTask={this.handleCreateUserTask}
                                                    handleNewQuotaChange={this.handleNewQuotaChange}
                                                    handleNewTaskInputFocus={this.handleNewTaskInputFocus}
                                                    handleProjectSelect={this.handleSelectProjectForNewUT}
                                                    handleTaskSelect={this.handleSelectTaskForNewUT}

                                                    newUTProjectError={this.state.newUTProjectError}
                                                    projects={this.props.projects}
                                                    taskError={this.state.newUTTaskError}
                                                    newUTProject={this.newUTProject}
                                                    tasks={this.props.tasks}
                                                    newUTQuota={this.state.newUTQuota}
                                                    />
                                    :
                                        null
                            }
                        </div>
                        <div className="panel-footer">
                            <button title="Save changes" ref="updateButton" onBlur={this.handleUpdateBlur} onFocus={this.handleUpdateFocus} onClick={this.handleSave} className="btn btn-default">Update</button>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

UsersOverviewUserPill.propTypes = {
    dispatch: PropTypes.func,
    handleClick: PropTypes.func,
    id: PropTypes.number,
    isUserPillActive: PropTypes.bool,
    isUserActive: PropTypes.bool,
    loading: PropTypes.bool,
    projects: PropTypes.array,
    tasks: PropTypes.array,
    user: PropTypes.object,
    userTasks: PropTypes.array,
};


const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        loading: state.projects.loading || state.userTasks.loading,
        projects: state.projects.projectsForUsersOverview,
        projectsByUser: state.projects.projectsByUser,
        selectedTask: state.tasks.selectedTask,
        selectedProject: state.projects.selectedProject,
        tasks: state.tasks.allTasks,
        tasksLoading: state.tasks.loading,
        userByID: state.users.userByID,
        userTasks: state.userTasks.userTasksByUser.sort(userTaskSorter),
        usersForUsersOverview: state.users.usersForUsersOverview,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersOverviewUserPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/UsersOverviewUserPill.js
 **/